import type ConversationType from 'owa-service/lib/contract/ConversationType';
import type ItemId from 'owa-service/lib/contract/ItemId';
import type TableViewConversationRelation from 'mini-mail-list-store/lib/store/schema/TableViewConversationRelation';

function getEffectiveMentioned(conversationType: ConversationType): boolean {
    return conversationType.GlobalMentionedMe || conversationType.GlobalAtAllMention;
}

export const mapConversationTypeToConversationRelation = (
    conversationType: ConversationType
): TableViewConversationRelation =>
    ({
        categories: conversationType.Categories,
        charm: conversationType.Charm ? conversationType.Charm : 'None',
        effectiveMentioned: getEffectiveMentioned(conversationType),
        flagStatus: conversationType.FlagStatus,
        hasAttachments: conversationType.HasAttachments,
        hasDrafts: conversationType.DraftItemIds && conversationType.DraftItemIds.length > 0,
        hasIrm: conversationType.HasIrm,
        iconIndex: conversationType.IconIndex,
        id: conversationType.ConversationId.Id,
        importance: conversationType.Importance,
        instanceKey: conversationType.InstanceKey,
        itemClasses: conversationType.ItemClasses,
        itemIds: conversationType.ItemIds.map(baseItemId => (baseItemId as ItemId).Id),
        lastDeliveryOrRenewTimeStamp: conversationType.LastDeliveryOrRenewTime,
        lastDeliveryTimeStamp: conversationType.LastDeliveryTime,
        lastModifiedTimeStamp: conversationType.LastModifiedTime,
        parentFolderId: conversationType.ParentFolderId ? conversationType.ParentFolderId.Id : null,
        previewText: conversationType.Preview,
        systemCategories: conversationType.SystemCategories,
        uniqueSenders: conversationType.UniqueSenders,
        uniqueRecipients: conversationType.UniqueRecipients,
        unreadCount: conversationType.UnreadCount,
        lastSender: conversationType.LastSender
            ? conversationType.LastSender
            : conversationType.From, // lastSender is null in search response, use From instead,
    } as TableViewConversationRelation);
